module.exports = __webpack_public_path__ + "img/memcached.1abcee01.svg";